import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NavbarComponent } from './navbar/navbar.component';
import { LayoutModule } from '@angular/cdk/layout';

import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { UserService } from './services/user.service';
import { PublicacionService } from './services/publicacion.service';
import { EspectaculoService } from './services/espectaculo.service';
import { MaratonService } from './services/maraton.service';
import { ActividadService } from './services/actividad.service';
import { PeliculaService } from './services/pelicula.service';
import { PeliculaHorarioService } from './services/pelicula-horario.service';
import { ServicioService } from './services/servicio.service';


import { MatToolbarModule, MatSidenavModule } from '@angular/material';
import { MaterialModule } from './material-module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PublicacionListComponent } from './publicacion-list/publicacion-list.component';
import { LoginComponent } from './login/login.component';
import { PublicacionEditorComponent } from './publicacion-editor/publicacion-editor.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { EspectaculoListComponent } from './espectaculo-list/espectaculo-list.component';
import { EspectaculoEditorComponent } from './espectaculo-editor/espectaculo-editor.component';
import { PublicacionImgExtraEditorComponent } from './publicacion-img-extra-editor/publicacion-img-extra-editor.component';
import { MaratonEditorComponent } from './maraton-editor/maraton-editor.component';
import { MaratonListComponent } from './maraton-list/maraton-list.component';
import { ActividadListComponent } from './actividad-list/actividad-list.component';
import { ActividadEditorComponent } from './actividad-editor/actividad-editor.component';
import { ServicioListComponent } from './servicio-list/servicio-list.component';
import { ServicioEditorComponent } from './servicio-editor/servicio-editor.component';
import { ServicioImgExtraEditorComponent } from './servicio-img-extra-editor/servicio-img-extra-editor.component';
import { PeliculaListComponent } from './pelicula-list/pelicula-list.component';
import { PeliculaEditorComponent } from './pelicula-editor/pelicula-editor.component';
import { PeliculaHorarioEditorComponent } from './pelicula-horario-editor/pelicula-horario-editor.component';

// import { MatToolbarModule } from '@angular/material/toolbar';
// import { MatButtonModule } from '@angular/material/button';
// import { MatSidenavModule } from '@angular/material/sidenav';
// import { MatIconModule } from '@angular/material/icon';
// import { MatListModule } from '@angular/material/list';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    DashboardComponent,
    PublicacionListComponent,
    LoginComponent,
    PublicacionEditorComponent,
    ConfirmDialogComponent,
    EspectaculoListComponent,
    EspectaculoEditorComponent,
    PublicacionImgExtraEditorComponent,
    MaratonEditorComponent,
    MaratonListComponent,
    ActividadListComponent,
    ActividadEditorComponent,
    ServicioListComponent,
    ServicioEditorComponent,
    ServicioImgExtraEditorComponent,
    PeliculaListComponent,
    PeliculaEditorComponent,
    PeliculaHorarioEditorComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,

    HttpClientModule,
    MaterialModule,
    FormsModule,

    LayoutModule,
    MatToolbarModule,
    MatSidenavModule,

  ],
  providers: [
    UserService,
    PublicacionService,
    EspectaculoService,
    MaratonService,
    ActividadService,
    PeliculaService,
    PeliculaHorarioService,
    ServicioService
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    PeliculaEditorComponent,
    PeliculaHorarioEditorComponent,
    ActividadEditorComponent,
    ServicioEditorComponent,
    ServicioImgExtraEditorComponent,
    MaratonEditorComponent,
    EspectaculoEditorComponent,
    PublicacionEditorComponent,
    PublicacionImgExtraEditorComponent,
    ConfirmDialogComponent
  ]
})
export class AppModule { }
